<div class="vsc-list">
  <!-- ── Toolbar ─────────────────────────────────────────────────────────── -->
  <div class="vsc-list__toolbar">
    <div class="vsc-list__heading-group">
      <h1 class="vsc-list__heading">Vendor Score Card</h1>
      @if (compiledAt()) {
        <p class="vsc-list__compiled-at mds-text--small-normal mds-neutral--weak__text-color">
          Scores compiled on: {{ compiledAtLabel() }}
          @if (compiledAtHiddenCount() > 0) {
            <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
              <button
                type="button"
                slot="trigger"
                class="vsc-list__compiled-at-info"
                aria-label="Show all compile times"
                (click)="openCompiledAtDialog()">
                <mc-icon icon="info-circle" size="16"></mc-icon>
              </button>
              <span>+{{ compiledAtHiddenCount() }} more compile times</span>
            </mc-tooltip>
          }
          <span class="vsc-list__compiled-at-tz">(local time)</span>
        </p>
      }
    </div>

    <div class="vsc-list__toolbar-right">
      <div class="vsc-list__toolbar-controls">
        <!-- Period selector (monthly only) -->
        <div class="vsc-period" #periodContainer>
          <button type="button" class="vsc-period__trigger" (click)="togglePeriodDropdown()">
            <mc-icon icon="calendar" size="16"></mc-icon>
            <span>{{ selectedMonth() }}</span>
            <mc-icon [attr.icon]="periodDropdownOpen() ? 'chevron-up' : 'chevron-down'" size="16"></mc-icon>
          </button>

          @if (periodDropdownOpen()) {
            <div class="vsc-period__dropdown">
              <div class="vsc-period__scroll-list">
                <p class="vsc-period__section-label mds-text--small-normal mds-neutral--weak__text-color">Select Month</p>
                @for (m of monthOptions; track m) {
                  <button
                    type="button"
                    class="vsc-period__option"
                    [class.vsc-period__option--selected]="m === selectedMonth()"
                    (click)="selectMonth(m)">
                    {{ m }}
                  </button>
                }
              </div>
            </div>
          }
        </div>

        <!-- Downloads -->
        <mc-menu class="vsc-list__downloads" fit="small" position="bottom-right" [zindex]="200">
          <mc-button
            slot="trigger"
            fit="small"
            appearance="neutral"
            variant="outlined"
            icon="tray-arrow-down"
            trailingicon="chevron-down"
            label="Downloads"
            [loading]="isDownloading()">
          </mc-button>

          <!-- mc-list raises `listchange` for both a click and a keyboard Enter/Space, so the
               menu stays operable from the keyboard without a click handler per item. -->
          <mc-list fit="small" width="full-width" (listchange)="onDownloadSelected($event)">
            <mc-list-item fit="small" label="Summary" value="summary"></mc-list-item>
            <mc-list-item fit="small" label="Detailed" value="detailed"></mc-list-item>
          </mc-list>
        </mc-menu>
      </div>
    </div>
  </div>

  <!-- ── Geo filter ────────────────────────────────────────────────────── -->
  <div class="vsc-list__filter-row">
    <div class="vsc-list__geo-filter">
      <app-aems-geo-filter [hiddenlabel]="true" (shopCodesChange)="onGeoShopCodesChange($event)" />
    </div>
  </div>

  <!-- ── Table ──────────────────────────────────────────────────────────── -->
  @if (isLoading()) {
    <div class="vsc-list__state-center">
      <mc-loading-indicator label="Loading vendor scores" hiddenlabel variant="ring" fit="small"></mc-loading-indicator>
    </div>
  } @else if (dataError()) {
    <div class="vsc-list__state-center">
      <p class="mds-neutral--weak__text-color mds-text--medium-normal">{{ dataError() }}</p>
    </div>
  } @else {
    <app-vsc-grid [rows]="filteredRows()" [month]="selectedMonth()" />
  }

  <!-- ── Other compile times ────────────────────────────────────────────── -->
  <mc-modal
    fit="medium"
    dimension="small"
    width="480px"
    height="auto"
    heading="Other compile times"
    [open]="compiledAtDialogOpen()"
    (closed)="closeCompiledAtDialog()">
    <p class="mds-body mds-neutral--weak__text-color">
      Scores for this period were compiled in more than one run. The remaining runs (local time):
    </p>
    <ul class="vsc-list__compiled-at-list">
      @for (time of compiledAtOtherRuns(); track time) {
        <li class="mds-body">{{ time }}</li>
      }
    </ul>
    <mc-button
      slot="secondaryAction"
      appearance="neutral"
      variant="outlined"
      (click)="closeCompiledAtDialog()"
      (keydown.enter)="closeCompiledAtDialog()">
      Close
    </mc-button>
  </mc-modal>
</div>
